/*
===============================================================================================================
                                 Copyright 2025-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import apiClient from '@/utilities/api-client';

export const getCompanyStatus = async ({ organisationId, token, hostId }) => {
  const authHeaders = {
    headers: {
      Authorization: token,
    },
  };

  try {
    const { data } = await apiClient.get(
      `${hostId}/get-company/${organisationId}`,
      authHeaders,
    );

    return {
      data: { companyEnabled: data?.enabled },
    };
  } catch (error) {
    throw new Error(error.message);
  }
};

export default getCompanyStatus;
